import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
// components
import Notifications from '../Notifications';
// calendar libraries
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// services
import DealerService from '../../services/DealerService';
// import ProductTypeService from '../../services/ProductTypeService';
// other
import moment from 'moment';
import Select from 'react-select';
import {
    Row,
    Col
} from 'reactstrap';
// icons
import greyX from '../../images/grey-x.svg';


function ContractFiltersModal({ 
    contractsFilters, filtersModalOpen, handleFiltersModalClose, handleSubmitFilters, applyResetTable 
}) {

    const initializeDealerLabel = () => {
        if (contractsFilters.dealer !== null) {
            return {
                value: contractsFilters.dealer.name,
                label: contractsFilters.dealer.name
            }
        } else {
            return null
        }
    };

    const [initialRender, setInitialRender] = useState(true)
    const [vinSearchFilter, setVinSearchFilter] = useState(contractsFilters.vin)
    const [allDealers, setAllDealers] = useState([]);
    const [allDealersLabel, setAllDealersLabel] = useState([])
    const [dealer, setDealer] = useState(contractsFilters.dealer);
    const [dealerLabel, setDealerLabel] = useState(() => initializeDealerLabel())
    // date
    const [activationStartDate, setActivationStartDate] = useState(moment(contractsFilters.activationStartDate))
    const [activationEndDate, setActivationEndDate] = useState(moment(contractsFilters.activationEndDate))
    const [updatedStartDate, setUpdatedStartDate] = useState(contractsFilters.updatedStartDate !== null ? moment(contractsFilters.updatedStartDate) : null)
    const [updatedEndDate, setUpdatedEndDate] = useState(contractsFilters.updatedEndDate !== null ? moment(contractsFilters.updatedEndDate) : null)

    const [finalizedStartDate, setFinalizedStartDate] = useState(contractsFilters.finalizedStartDate !== null ? moment(contractsFilters.finalizedStartDate) : null)
    const [finalizedEndDate, setFinalizedEndDate] = useState(contractsFilters.finalizedEndDate !== null ? moment(contractsFilters.finalizedEndDate) : null)
    const [cancelledStartDate, setCancelledStartDate] = useState(contractsFilters.cancelledStartDate !== null ? moment(contractsFilters.cancelledStartDate) : null)
    const [cancelledEndDate, setCancelledEndDate] = useState(contractsFilters.cancelledEndDate !== null ? moment(contractsFilters.cancelledEndDate) : null)
    

    const [idSearchFilter, setIdSearchFilter] = useState(contractsFilters.contractId)
    const [customerSearchFilter, setCustomerSearchFilter] = useState(contractsFilters.contractCustomer)
    // const [productNameFilter, setProductNameFilter] = useState(contractsFilters.contractProductName)
    // const [productTypeFilter, setProductTypeFilter] = useState(contractsFilters.contractProductType)
    // const [productTypeLabels, setProductTypeLabels] = useState([])

    // get dropdown info
    useEffect(() => { 
        setInitialRender(false)

        // get dealers
        DealerService.getAllDealers().then(response => {
            setAllDealers(response.data)
            setAllDealersLabel(response.data.map((dealer) => {
                return {
                    value: dealer.name,
                    label: dealer.name
                }
            }).sort((a, b) => a['label'].localeCompare(b['label'])))
        }).catch(err => {
            Notifications("error", err['message'])
        })

        // // get product types
        // ProductTypeService.getProductTypes()
        //     .then(response => {
        //         let productTypeList = response.data.map((pt) => {
        //             return {
        //                 value: pt.id,
        //                 label: pt.name
        //             }
        //         })
        //         productTypeList.sort((a, b) => a['label'].localeCompare(b['label']))
        //         setProductTypeLabels(productTypeList)
        //     }, e => {
        //         console.log(e)
        //         Notifications('error', 'Unable to fetch product types list.')
        //     })
    }, [])


    useEffect(() => {
        if (!initialRender) {
            setVinSearchFilter('')
            setDealer(null)
            setDealerLabel(null)
            setActivationStartDate(moment().startOf('day').subtract(1, 'months'))
            setActivationEndDate(moment())
            setUpdatedStartDate(null)
            setUpdatedEndDate(null)
            setFinalizedStartDate(null)
            setFinalizedEndDate(null)
            setCancelledStartDate(null)
            setCancelledEndDate(null)
            setIdSearchFilter('')
            setCustomerSearchFilter('')
            // setProductNameFilter('')
            // setProductTypeFilter(null)
        }
    }, [applyResetTable])

    const handleDealerChange = (dealerLabel) => {
        setDealerLabel(dealerLabel)
        const selectedDealer = allDealers.find((dealer) => dealer.name === dealerLabel.value)
        setDealer(selectedDealer)
    }

    // const handleProductTypeChange = (productTypeLabel) => {
    //     setProductTypeFilter(productTypeLabel)
    // }


    const onSubmit = () => {

        if (finalizedStartDate !== null && finalizedEndDate === null) {
            Notifications("error", 'Please enter a finalized end date.')
        } else if (finalizedStartDate === null && finalizedEndDate !== null) {
            Notifications("error", 'Please enter a finalized start date.')
        } else if (cancelledStartDate !== null && cancelledEndDate === null) {
            Notifications('error', 'Please enter a cancelled end date')
        } else if (cancelledStartDate === null && cancelledEndDate !== null) {
            Notifications('error', 'Please enter a cancelled start date.')
        } else {
            const filters = {
                vinSearchFilter: vinSearchFilter,
                dealerSearchFilter: dealer,
                activationStartDateDay: moment({
                    year: activationStartDate.utc().get('year'),
                    month: activationStartDate.utc().get('month'),
                    date: activationStartDate.utc().get('date'),
                }),
                activationEndDateDay: moment({
                    year: activationEndDate.utc().get('year'),
                    month: activationEndDate.utc().get('month'),
                    date: activationEndDate.utc().get('date'),
                }),
                finalizedStartDateDay: finalizedStartDate !== null ? moment({
                    year: finalizedStartDate.utc().get('year'),
                    month: finalizedStartDate.utc().get('month'),
                    date: finalizedStartDate.utc().get('date'),
                }) : null,
                finalizedEndDateDay: finalizedEndDate !== null ? moment({
                    year: finalizedEndDate.get('year'),
                    month: finalizedEndDate.get('month'),
                    date: finalizedEndDate.get('date'),
                }) : null,
                cancelledStartDateDay: cancelledStartDate !== null ? moment({
                    year: cancelledStartDate.utc().get('year'),
                    month: cancelledStartDate.utc().get('month'),
                    date: cancelledStartDate.utc().get('date'),
                }) : null,
                cancelledEndDateDay: cancelledEndDate !== null ? moment({
                    year: cancelledEndDate.get('year'),
                    month: cancelledEndDate.get('month'),
                    date: cancelledEndDate.get('date'),
                }) : null,
                idSearchFilter: idSearchFilter,
                customerSearchFilter: customerSearchFilter
                // productNameFilter: productNameFilter,
                // productTypeFilter: productTypeFilter
            }
            handleSubmitFilters(filters) 
        }
    }; 

    return (
        <Modal
            isOpen={filtersModalOpen}
            onRequestClose={handleFiltersModalClose}
            closeTimeoutMS={200}
            ariaHideApp={false}
            className='modal-contract__filters'
        >
            <div className="modal-header">
                <h2>Filters</h2>
                <button className="close" onClick={handleFiltersModalClose}>
                    <img src={greyX} alt="Close"/>
                </button>
            </div>
            <Row>
                <Col xs={12} md={12}>
                    <div>
                        <span>Contract ID:</span>
                        <input 
                            type='text'
                            placeholder='Enter Contract ID'
                            value={idSearchFilter}
                            onChange={(e) => setIdSearchFilter(e.target.value)}
                            className='input input__form'
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <div>
                        <span>VIN:</span>
                        <input 
                            type='text'
                            placeholder='Enter VIN'
                            value={vinSearchFilter}
                            onChange={(e) => setVinSearchFilter(e.target.value)}
                            className='input input__form'
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                {/*<Col xs={12} md={6}>
                    <div>
                        <span>Customer:</span>
                        <input 
                            type='text'
                            placeholder='Enter Contract Owner Name'
                            value={customerSearchFilter}
                            onChange={(e) => setCustomerSearchFilter(e.target.value)}
                            className='input input__form'
                        />
                    </div>
                </Col>*/}
                <Col xs={12} md={12}>
                    <div>
                        Dealer Filter:
                        <Select 
                            options={allDealersLabel}
                            value={dealerLabel}
                            onChange={handleDealerChange}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <div>
                        Activation Date Filter: 
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DemoContainer 
                                components={['DatePicker', 'DatePicker']}
                                sx={{
                                    "&.MuiStack-root": {
                                        paddingTop: "0px"
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1.6rem"
                                    }
                                }}
                            >
                                <DatePicker  
                                    value={activationStartDate}
                                    onChange={(e) => setActivationStartDate(e)}
                                    maxDate={moment()}
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                ".MuiPaper-root": { 
                                                    borderRadius: "10px",
                                                    paddingTop: "0px"
                                                },
                                                ".MuiInputBase-formControl": {
                                                    borderRadius: "20px"
                                                },
                                                ".MuiDayCalendar-weekDayLabel": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersDay-root": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersCalendarHeader-label": {
                                                    fontSize: "1.6rem"
                                                },
                                                zIndex: 9999
                                            }
                                        }
                                    }}
                                />
                                <DatePicker
                                    value={activationEndDate}
                                    onChange={(e) => setActivationEndDate(e)}
                                    maxDate={moment()}
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                ".MuiPaper-root": { 
                                                    borderRadius: "10px",
                                                    paddingTop: "0px"
                                                },
                                                ".MuiInputBase-formControl": {
                                                    borderRadius: "20px"
                                                },
                                                ".MuiDayCalendar-weekDayLabel": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersDay-root": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersCalendarHeader-label": {
                                                    fontSize: "1.6rem"
                                                },
                                                zIndex: 9999
                                            }
                                        }
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <div>
                        Finalized Date Filter: 
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DemoContainer 
                                components={['DatePicker', 'DatePicker']}
                                sx={{
                                    "&.MuiStack-root": {
                                        paddingTop: "0px"
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1.6rem"
                                    }
                                }}
                            >
                                <DatePicker  
                                    value={finalizedStartDate}
                                    onChange={(e) => setFinalizedStartDate(e)}
                                    maxDate={moment()}
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                ".MuiPaper-root": { 
                                                    borderRadius: "10px",
                                                    paddingTop: "0px"
                                                },
                                                ".MuiInputBase-formControl": {
                                                    borderRadius: "20px"
                                                },
                                                ".MuiDayCalendar-weekDayLabel": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersDay-root": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersCalendarHeader-label": {
                                                    fontSize: "1.6rem"
                                                },
                                                zIndex: 9999
                                            }
                                        }
                                    }}
                                />
                                <DatePicker
                                    value={finalizedEndDate}
                                    onChange={(e) => setFinalizedEndDate(e)}
                                    maxDate={moment()}
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                ".MuiPaper-root": { 
                                                    borderRadius: "10px",
                                                    paddingTop: "0px"
                                                },
                                                ".MuiInputBase-formControl": {
                                                    borderRadius: "20px"
                                                },
                                                ".MuiDayCalendar-weekDayLabel": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersDay-root": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersCalendarHeader-label": {
                                                    fontSize: "1.6rem"
                                                },
                                                zIndex: 9999
                                            }
                                        }
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <div>
                        Cancelled Date Filter: 
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DemoContainer 
                                components={['DatePicker', 'DatePicker']}
                                sx={{
                                    "&.MuiStack-root": {
                                        paddingTop: "0px"
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1.6rem"
                                    }
                                }}
                            >
                                <DatePicker  
                                    value={cancelledStartDate}
                                    onChange={(e) => setCancelledStartDate(e)}
                                    maxDate={moment()}
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                ".MuiPaper-root": { 
                                                    borderRadius: "10px",
                                                    paddingTop: "0px"
                                                },
                                                ".MuiInputBase-formControl": {
                                                    borderRadius: "20px"
                                                },
                                                ".MuiDayCalendar-weekDayLabel": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersDay-root": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersCalendarHeader-label": {
                                                    fontSize: "1.6rem"
                                                },
                                                zIndex: 9999
                                            }
                                        }
                                    }}
                                />
                                <DatePicker
                                    value={cancelledEndDate}
                                    onChange={(e) => setCancelledEndDate(e)}
                                    maxDate={moment()}
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                ".MuiPaper-root": { 
                                                    borderRadius: "10px",
                                                    paddingTop: "0px"
                                                },
                                                ".MuiInputBase-formControl": {
                                                    borderRadius: "20px"
                                                },
                                                ".MuiDayCalendar-weekDayLabel": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersDay-root": {
                                                    fontSize: "1.6rem"
                                                },
                                                ".MuiPickersCalendarHeader-label": {
                                                    fontSize: "1.6rem"
                                                },
                                                zIndex: 9999
                                            }
                                        }
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </Col>
            </Row>
            <div className='modal-footer'>
                <button
                    onClick={() => handleFiltersModalClose()}
                    className='footer__cancel-button'
                >
                    <div className="vertical-align-div">
                        <span>Cancel</span>
                    </div>
                    
                </button>
                <button
                    onClick={() => onSubmit()}
                    className='footer__save-button'
                >
                    <div className='vertical-align-div'>
                        <span>Apply Filters</span>
                    </div>
                </button>
            </div>
        </Modal>
    );
}

const mapStateToProps = (state) => {
    return {
        contractsFilters: state.contractsFilters
    };
};

export default connect(mapStateToProps)(ContractFiltersModal);